import React, { useCallback, useState } from 'react';
import { Grid, ConfigContext } from '../../base-ui/lib';
import { useNavigate } from 'react-router-dom';
import { Avatar, Box } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import TeamGridToolbar from './TeamGridToolbar';
import EmptySearchState from '../../base-ui/Grid/components/EmptySearchState';
import { useGlobalState } from 'src/stateProviders/GlobalStateProvider';
import Role from 'src/enums/role';

const EmptyStateComponent = () => <EmptySearchState />;

const TeamMember = () => {
	const { config } = React.useContext(ConfigContext);
	const { appUser } = useGlobalState();
	const navigate = useNavigate();
	const gridRef = React.useRef<any>(null);

	const [filter, setFilter] = useState('');
	const [role, setRole] = useState('');
	const [company, setCompany] = useState('');
	const [allData, setAllData] = useState([]);

	const renderToolbar = useCallback(
		() => (
			<TeamGridToolbar
				filter={filter}
				setFilter={setFilter}
				role={role}
				setRole={setRole}
				company={company}
				setCompany={setCompany}
				allData={allData}
				handleRefresh={() => gridRef.current?.onRefresh()}
				onAdd={null}
			/>
		),
		[filter, setFilter, role, setRole, company, setCompany, allData]
	);

	const filterList = [
		{
			id: 'firstName',
			label: 'First Name',
			dataType: 'string',
			defaultValue: '',
		},
		{
			id: 'lastName',
			label: 'Last Name',
			dataType: 'string',
			defaultValue: '',
		},
		{ id: 'email', label: 'Email', dataType: 'string', defaultValue: '' },
		{ id: 'phoneNumber', label: 'Phone', dataType: 'string', defaultValue: '' },
		{ id: 'company', label: 'Company', dataType: 'string', defaultValue: '' },
		{ id: 'role', label: 'Role', dataType: 'string', defaultValue: '' },
	];

	const headCells = [
		{
			field: 'profilePicture',
			headerName: '',
			flex: 0.5,
			sortable: false,
			renderCell: ({ row }) => {
				const profilePicture = row.profilePicture;
				return (
					<Box display="flex" alignItems="center" height="100%">
						<Avatar
							src={profilePicture ? profilePicture : '/avatar.jpg'}
							alt="Profile Photo"
							slotProps={{
								img: {
									referrerPolicy: 'no-referrer',
									style: { objectFit: 'contain' },
								},
							}}
						/>
					</Box>
				);
			},
		},
		{
			field: 'firstName',
			headerName: 'First Name',
			flex: 2,
			sortable: true,
		},
		{
			field: 'lastName',
			headerName: 'Last Name',
			flex: 1.5,
			sortable: true,
		},
		{
			field: 'email',
			headerName: 'Email',
			flex: 2,
			sortable: true,
		},
		{
			field: 'phoneNumber',
			headerName: 'Phone',
			flex: 1,
			sortable: true,
		},
		{
			field: 'company',
			headerName: 'Company',
			flex: 1.5,
			sortable: true,
		},
		{
			field: 'role',
			headerName: 'Role',
			flex: 1,
			sortable: true,
		},
	];

	if ((appUser?.role.roleName || '') == Role.SUPER_ADMIN.toString()) {
		headCells.push({
			field: 'actions',
			type: 'actions',
			flex: 0.7,
			getActions: ({ row }) => [
				<GridActionsCellItem
					key="view"
					label="View"
					onClick={() => navigate(`/team/${row.id}`)}
					showInMenu
				/>,
				<GridActionsCellItem
					key="edit"
					label="Edit"
					onClick={() => navigate(`/team/${row.id}/edit`)}
					showInMenu
				/>,
				<GridActionsCellItem
					key="delete"
					label="Delete"
					onClick={() => navigate(`/team/${row.id}/delete`)}
					showInMenu
				/>,
			],
		});
	}
	return (
		<Grid
			ref={gridRef}
			headCells={headCells}
			filterList={filterList}
			searchEndpont={`${config.uri.base}/users`}
			pageSizeOptions={[10, 25, 50]}
			selectableRows={false}
			hybridMode={true}
			initialPageSize={2000}
			toolbar={renderToolbar}
			showToolbar
			onDataLoad={setAllData}
			options={{ filter, role, company }}
			customNoRowsOverlay={EmptyStateComponent}
		/>
	);
};

export default TeamMember;
